"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var lodash_1 = require("lodash");
var product_preview_1 = require("./product_preview");
var scrollable_list_1 = require("./scrollable_list");
var url_helpers_1 = require("../shared/url_helpers");
var api_request_1 = require("../api_request");
var I18n = require("i18n-js");
var PER_PAGE = 20;
var SEARCH_DELAY = 200;
var ProductSearchForm = /** @class */ (function (_super) {
    tslib_1.__extends(ProductSearchForm, _super);
    function ProductSearchForm(props) {
        var _this = _super.call(this, props) || this;
        _this.isComponentMounted = false;
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.renderProduct = _this.renderProduct.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleContainerFocus = _this.handleContainerFocus.bind(_this);
        if (_this.props.disableDebounce) {
            _this.handleChangeDebounced = _this.handleChangeDebounced.bind(_this);
        }
        else {
            _this.handleChangeDebounced = lodash_1.debounce(_this.handleChangeDebounced.bind(_this), SEARCH_DELAY);
        }
        _this.state = {
            results: props.results,
            hideItems: false,
        };
        return _this;
    }
    ProductSearchForm.prototype.componentDidMount = function () {
        var _this = this;
        document.addEventListener('click', function () { return _this.handleDocumentClick(); });
        this.isComponentMounted = true;
    };
    ProductSearchForm.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.results !== this.state.results) {
            this.setState({ results: nextProps.results });
        }
    };
    ProductSearchForm.prototype.componentWillUnmount = function () {
        var _this = this;
        document.removeEventListener('click', function () { return _this.handleDocumentClick(); });
        this.isComponentMounted = false;
    };
    ProductSearchForm.prototype.handleDocumentClick = function () {
        if (this.isComponentMounted && this.state.results.length > 0 && this.state.hideItems === false) {
            // hide the results
            this.setState({ hideItems: true });
        }
    };
    ProductSearchForm.prototype.handleContainerClick = function (e) {
        e.nativeEvent.stopImmediatePropagation();
    };
    ProductSearchForm.prototype.handleContainerFocus = function () {
        // show the items
        this.setState({ hideItems: false });
    };
    ProductSearchForm.prototype.handleChange = function (e) {
        this.props.onChange(e);
        this.handleChangeDebounced(e.target.value);
    };
    ProductSearchForm.prototype.handleChangeDebounced = function (search) {
        var _this = this;
        if (search && search.length) {
            api_request_1.V3.get(url_helpers_1.default.myListingsPath, {
                query: search,
                per_page: PER_PAGE,
                not_ids: this.props.currentListingIds,
                include_lp: this.props.includeLP,
            }).done(function (response) {
                if (_this.isComponentMounted) {
                    _this.setState({
                        results: response.listings,
                    });
                }
            });
        }
        else {
            this.setState({
                results: [],
            });
        }
    };
    ProductSearchForm.prototype.handleSubmit = function (e) {
        e.preventDefault();
        var focusedProduct = this.refs.scrollableList.focusedItem();
        if (focusedProduct) {
            this.props.productSelected(focusedProduct);
        }
    };
    ProductSearchForm.prototype.renderProduct = function (product) {
        return (React.createElement(product_preview_1.default, { product: product, handleClick: this.props.productSelected }));
    };
    ProductSearchForm.prototype.render = function () {
        return (React.createElement("div", { onClick: this.handleContainerClick, onFocus: this.handleContainerFocus },
            React.createElement(scrollable_list_1.default, { name: "search", type: "text", placeholder: I18n.t('discovery.productSearchForm.placeholder'), changeEvent: this.handleChange, onEnter: this.handleSubmit, autoComplete: "off", autoFocus: "on", items: this.state.results, renderItem: this.renderProduct, ref: "scrollableList", inputValue: this.props.inputValue, hideItems: this.state.hideItems })));
    };
    ProductSearchForm.defaultProps = {
        results: [],
        onChange: function () { },
        includeLP: false,
    };
    return ProductSearchForm;
}(React.Component));
exports.default = ProductSearchForm;
//# sourceMappingURL=product_search_form.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/product_search_form/product_search_form.js
// module id = YIDa
// module chunks = 20 21